import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col, Button, ListGroup, ListGroupItem, DropdownButton, MenuItem } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { withNamespaces, Trans } from 'react-i18next';
import Card from '../../common/components/Card';

class Center extends Component {
    constructor(props) {
        super(props);

        this.handleCityChange = this.handleCityChange.bind(this);
        this.state = {
            selectedCity: this.props.parentCity,
            cityCenters: this.props.centers.filter(c => c.city === this.props.parentCity && (!this.props.isIndividualConsultation || c.isIndividualConsultation))
        };
    }

    renderView() {
        const { selectedCenter, t } = this.props;

        const icon = <FontAwesome name='check' className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -10, width: 35, height: 35, lineHeight: '35px', fontSize: 18 }} />;

        return (
            <div>
                <div className='steps_title'>{t('FO_Booking_Center_Title')}</div>
                <Row>
                    <Col sm={6} md={4}>
                        <Card title={<span>{icon} {selectedCenter.name}</span>}>
                            <div>{selectedCenter.address}</div>
                            <div>{selectedCenter.phoneNumber ? selectedCenter.phoneNumber : (selectedCenter.mobilePhone ? selectedCenter.mobilePhone : '')}</div>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <Link to='class' className='btn btn-primary pull-right btn-block-xxs'>{t('FO_Booking_Center_Continue')} <FontAwesome name='arrow-circle-right' /></Link>
                        <Link to='center?edit=true' className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {t('FO_Booking_Center_Select')}</Link>
                    </Col>
                </Row>
            </div>
        );
    }

    handleCityChange(city) {
        this.setState({
            selectedCity: city,
            cityCenters: this.props.centers.filter(c => c.city === city && (!this.props.isIndividualConsultation || c.isIndividualConsultation))
        });
    }

    renderEdit() {
        const { onSelect, cities, t } = this.props;
        const centersList = this.state.cityCenters.map(c => {
            return (
                <Col sm={6} md={4} key={c.id}>
                    <Card title={c.name} onClick={() => onSelect(c)} style={{ cursor: 'pointer' }}>
                        <div>{c.address}</div>
                        <div>{c.phoneNumber ? c.phoneNumber : (c.mobilePhone ? c.mobilePhone : '')}</div>
                    </Card>
                </Col >
            );
        });

        return (
            <div>
                <div className='steps_title'>{t('FO_Booking_Center_Title')}</div>
                <div className='timetable-search'>
                    <div className='select-city'>
                        <DropdownButton id='searchCity' onSelect={key => this.handleCityChange(key)}
                            className='btn-block-xxs'
                            bsStyle={this.state.selectedCity ? 'primary' : 'default'}
                            title={this.state.selectedCity && this.props.centers.find(c => c.city === this.state.selectedCity) != undefined ? this.state.selectedCity : t('FO_TimetableSearch_City')}>
                            {cities && cities.sort().map(city => <MenuItem key={city} eventKey={city} >{city}</MenuItem>)}
                        </DropdownButton>
                    </div>
                </div>

                <Row>
                    {centersList}
                </Row>
                { this.state.cityCenters.length === 0 && <p className='steps_description'>{t('FO_Booking_Center_NoCentreInCity')}</p>}
            </div >
        );
    }

    render() {
        const { selectedCenter, changeSelectedCenter } = this.props;

        if (selectedCenter && !changeSelectedCenter) {
            return this.renderView();
        } else {
            return this.renderEdit();
        }
    }
}

export default withNamespaces()(Center);